import * as React from 'react';
import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';
import LoadingView from '../components/loading-view';
import {Definition, PredefinedField} from '../lib/types';
import {buildSectionTitle} from './helper';
import {Theme} from '@mui/styles';
import {Typography} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: '1.4rem',
    display: 'flex',
    alignItems: 'center'
  },
  sectionArea: {
    display: 'flex',
    //flexDirection: "row-reverse",
    alignItems: 'baseline'
  },
  formArea: {
    padding: 15
  },
  fieldArea: {
    display: 'flex',
    //flexDirection: "row-reverse",
    alignItems: 'center'
  },
  configIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginLeft: 5
  },
  instructions: {
    padding: 15
  },
  successIcon: {
    color: 'green',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  infoIcon: {
    color: '#005897',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  warnIcon: {
    color: 'gold',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  errorIcon: {
    color: '#f44336',
    fontSize: '0.9rem',
    paddingRight: 5
  },
  dialog: {
    minWidth:"90%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  path: string;
  data: any;
  definition: Definition;
  policyMessages?: Array<any>;
  suppressTitle?: boolean;
  onChangeAtPath: (path: string, newVal: any) => void;
  getValueForPath: (path: string) => any;
  adminMode?: boolean;
  onDefinitionChange?: (def: Definition) => void;
  onApplyConditional?: (
    basisPath: string,
    conditionalAttribute: any,
    i: any,
    field: PredefinedField
  ) => void;
  customRenderers?: any;
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  data: any;
  status: 'ready' | 'loading';
  editField?: any;
  editDefintion?: any;
};

class CustomDefinitionSection extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      data: this.preProcessData(props.data || {}),
      status: 'loading'
    };
  }

 componentDidMount() {
    // Initiate loading here is any loading is required.  Do not forget to also implement in UNSAFE_componentWillReceiveProps also
    this.setState({status: 'ready'});
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>,
    oldProps: Props & WithStyles<keyof typeof styles>
  ) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also
    this.setState({
      data: this.preProcessData(newProps.data || {}),
      status: 'ready'
    });
  }

  // preProcessData is where we can set up minimums establish defaults, etc.
  preProcessData = (data: any): any => {
    return data;
  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {
      definition,
      path,
      policyMessages,
      suppressTitle,
    } = this.props;
    const {status, data} = this.state;

    var sectionTitle: any = buildSectionTitle(
      classes,
      definition,
      path,
      policyMessages,
      suppressTitle
    );

    var instructions: any = null;

    if (!suppressTitle) {

      if (definition.instructions) {
        instructions = (
          <Typography
            className={classes.instructions}
            variant="body1"
            gutterBottom>
            {definition.instructions}
          </Typography>
        );
      }
    }
    // Here is where we update the field definition by


    if (!data) {
      console.error("expected data")
      return
    }

    switch (status) {
      case 'loading':
        // TODO:
        return <LoadingView classes={{}} />;
        break;

      default:
        return (
          <div className={classes.container}>
            {sectionTitle}
            {instructions}
            <div> Custom Section Stuff Goes here </div>
          </div>
        );
    }
  }

}

export default withStyles(styles)(CustomDefinitionSection);

